<template>
  <v-card class="card">
    <v-tabs v-model="tab" class="align-center" density="default" height="64">
      <v-tab ripple value="registeredUsers">Registered Users</v-tab>
      <v-spacer></v-spacer>
      <v-text-field
        class="align-self-right mt-0 pt-0"
        append-inner-icon="mdi-magnify"
        v-model="search"
        label="Search"
        :single-line="true"
        hide-details
        variant="outlined"
        density="compact"
      >
      </v-text-field>
    </v-tabs>

    <v-window v-model="tab">
      <v-data-table
        v-if="users"
        :headers="headersUsers"
        :items="users"
        :items-per-page="-1"
        hover
        v-model:expanded="expanded"
        show-expand
        :sort-by="tableSort"
        @update:sort-by="handleTableSort"
        :multi-sort="false"
        :loading="loadingUsers"
      >
        <template v-slot:item.hasNotes="{ item }">
          <v-badge
            v-if="item.adminNotes && item.adminNotes.length > 0"
            :content="item.adminNotes.length"
            color="primary"
            @click="toggleRowExpansion(item)"
            class="cursor-pointer"
          >
            <v-icon>mdi-note-text-outline</v-icon>
          </v-badge>
        </template>
        <template v-slot:item.firstname="{ item }">
          <div>
            {{
              (item.firstname + ' ' + item.lastname).length > 15 ? `${(item.firstname + ' ' + item.lastname).substring(0, 15)?.trim()}...` : (item.firstname + ' ' + item.lastname)
            }}
            <v-tooltip
              max-width="400px"
              location="top"
              activator="parent"
              v-if="(item.firstname + ' ' + item.lastname).length > 15"
            >
              {{ item.firstname + ' ' + item.lastname}}
            </v-tooltip>
          </div>
        </template>
        <template v-slot:item.projectsAndMemberships="{ item }">
          {{ formatProjectsAndMemberships(item) }}
        </template>
        <template v-slot:item.subscription="{ item }">
          <v-chip
            v-if="subscriptionTypeByEmail[item.email]"
            :color="subscriptionTypeByEmail[item.email] === 'Enterprise' ? 'amber-accent-4' : 'deep-purple-accent-3'"
            size="small"
            label
          >
            {{ subscriptionTypeByEmail[item.email] }}
          </v-chip>
          <v-chip
            v-else
            color="blue-grey-darken-1"
            size="small"
            label
          >
            Signup aborted
          </v-chip>
        </template>
        <template v-slot:item.lastLogin="{ item }">{{
          item.lastLogin && !item.lastLogin.startsWith('0000') ? item.lastLogin.substring(0, 10) : ''
        }}
        </template>
        <template v-slot:item.registrationDate="{ item }">
          {{ item.registrationDate ? item.registrationDate.substring(0, 10) : '' }}
        </template>
        <template v-slot:item.referralSource="{ item }">
          <div v-if="item.referralSource">
            {{
              item.referralSource.length > 15 ? `${item.referralSource.substring(0, 15)?.trim()}...` : item.referralSource
            }}
            <v-tooltip
              max-width="400px"
              location="top"
              activator="parent"
              v-if="item.referralSource && item.referralSource.length > 15"
            >
              {{ item.referralSource ? item.referralSource : '' }}
            </v-tooltip>
          </div>
          <div v-else>-</div>
        </template>
        <template v-slot:item.usageIntent="{ item }">
          <div v-if="item.usageIntent">
            {{
              item.usageIntent.length > 15 ? `${item.usageIntent.substring(0, 15)?.trim()}...` : item.usageIntent
            }}
            <v-tooltip
              max-width="400px"
              location="top"
              activator="parent"
              v-if="item.usageIntent && item.usageIntent.length > 15"
            >
              {{ item.usageIntent ? item.usageIntent : '' }}
            </v-tooltip>
          </div>
          <div v-else>-</div>
        </template>
        <template v-slot:bottom></template>

        <template v-slot:expanded-row="{ item }">
          <td :colspan="headersUsers.length">
            <v-card class="mx-4 mb-4 elevation-3">
              <v-data-table
                :headers="headersProjects"
                :items="getProjects(item.organisations)"
                :items-per-page="-1"
                hover
                hide-default-footer
                class="elevation-1"
              >
                <template v-slot:bottom></template>
                <template v-slot:item.workflows="{ item, index }">
                  <v-dialog
                    v-model="dialog[index]"
                    width="600"
                    :scrim="false">
                    <template v-slot:activator="{ props }">
                      <a href="#" v-bind="props" @click.prevent>{{ item.workflows?.items ? item.workflows.items.length : 0 }}</a>
                    </template>
                    <v-card>
                      <v-layout fluid justify-space-between align-top>
                        <div>
                          <v-card-title
                            class="title-h5"
                            primary-title
                          >
                            Workflows for project '{{ item.name }}'
                          </v-card-title>
                        </div>
                        <v-spacer></v-spacer>
                        <div shrink>
                          <v-btn variant="plain" icon color="grey" @click="dialog[index] = false">
                            <v-icon>mdi-close</v-icon>
                          </v-btn>
                        </div>
                      </v-layout>
                      <v-card-text class="pa-0">
                        <v-data-table
                          :headers="headersWorkflows"
                          :items="item.workflows?.items || []"
                          :items-per-page="-1"
                          hover
                          hide-default-footer
                          class="elevation-1"
                          disable-pagination
                        >
                          <template v-slot:bottom></template>
                          <template v-slot:item.name="{ item }">
                            <div style="cursor: pointer;" @click="gotoWorkflow(item.id, item.projectId)">{{
                              item.name
                            }}
                            </div>
                          </template>
                          <template v-slot:item.eventsLength="{ item }">{{ item.domainEvents?.length }}</template>
                        </v-data-table>
                      </v-card-text>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                          color="primary"
                          @click="dialog[index] = false">
                          Close
                        </v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                </template>
                <template v-slot:item.teamMembers="{ item }">{{
                  item.teamMembers?.items ? item.teamMembers.items.length : 0
                }}
                </template>
                <template v-slot:item.getAccess="{ item }">
                  <div v-if="alreadyTeamMember(item.teamMembers?.items || [])">Already team member</div>
                  <div v-else>
                    <v-btn @click="createTeamMember(item.id)">Become team member</v-btn>
                  </div>
                </template>
                <template v-slot:item.lastLogin="{ item }">{{
                  findLastLogin(item.teamMembers?.items || []).substring(0, 10)
                }}
                </template>
              </v-data-table>
            </v-card>
            <v-card class="mx-4 mb-4 elevation-3">
              <v-card-title>Notes</v-card-title>
              <v-card-text>
                <div class="mb-4">
                  <div class="d-flex align-start ga-4 mb-6">
                    <v-select
                      style="flex: 0 0 300px;"
                      v-model="newNoteTypes[item.id]"
                      :items="noteTypeOptions"
                      label="Note Type"
                      variant="outlined"
                      density="compact"
                      hide-details
                      @update:model-value="(val) => handleNoteTypeChange(item.id, val)"
                    />
                    <v-text-field
                      v-if="newNoteTypes[item.id] === 'Outgoing Email'"
                      v-model="senderEmailPrefixes[item.id]"
                      label="Sender Email"
                      variant="outlined"
                      density="compact"
                      :error-messages="senderEmailErrors[item.id]"
                      :suffix="`@${brand.emails.domain}`"
                      placeholder="support"
                      style="flex: 0 0 420px;"
                      @update:model-value="validateSenderEmail(item.id)"
                    />
                  </div>
                  <div class="w-50 d-flex align-end ga-4">
                    <div class="flex-grow-1 mr-4">
                      <v-text-field
                        v-if="newNoteTypes[item.id] === 'Outgoing Email'"
                        v-model="subjectLines[item.id]"
                        label="Email Subject"
                        variant="outlined"
                        density="compact"
                        hide-details
                        placeholder="Enter email subject..."
                        class="mb-4"
                        maxlength="78"
                      />
                      <v-textarea
                        v-model="newNotes[item.id]"
                        label="Add a new note for this user..."
                        rows="3"
                        auto-grow
                        hide-details
                        variant="outlined"
                        density="compact"
                      />
                    </div>
                    <div class="d-flex ga-2 align-self-end">
                      <v-btn
                        color="primary"
                        variant="outlined"
                        :loading="addingNoteState[item.id] === 'note'"
                        :disabled="!newNotes[item.id] || !!addingNoteState[item.id]"
                        @click="handleAddNote(item.id, false)"
                      >
                        Add Note
                      </v-btn>
                      <v-btn
                        v-if="newNoteTypes[item.id] === 'Outgoing Email'"
                        color="primary"
                        variant="flat"
                        :loading="addingNoteState[item.id] === 'email'"
                        :disabled="!newNotes[item.id] || !!addingNoteState[item.id] || !senderEmailPrefixes[item.id] || !!senderEmailErrors[item.id] || !subjectLines[item.id]?.trim()"
                        @click="handleAddNote(item.id, true)"
                      >
                        Add Note & Send Email
                      </v-btn>
                    </div>
                  </div>
                </div>

                <v-data-table
                  :headers="headersAdminNotes"
                  :items="item.adminNotes || []"
                  :items-per-page="-1"
                  :sort-by="[{ key: 'createdAt', order: 'desc' }]"
                  hover
                  hide-default-footer
                  class="elevation-1"
                >
                  <template v-slot:item.type="{ item: note }">
                    <v-chip
                      v-if="note.type"
                      :color="getNoteTypeColor(note.type)"
                      size="small"
                      label
                    >
                      {{ note.type }}
                    </v-chip>
                  </template>
                  <template v-slot:item.emailSent="{ item: note }">
                    <div v-if="note.type === 'Outgoing Email'">
                      <v-icon
                        :color="note.emailSent ? 'success' : 'grey'"
                        size="small"
                      >
                        {{ note.emailSent ? 'mdi-email-check' : 'mdi-email-off-outline' }}
                      </v-icon>
                      <v-tooltip
                        v-if="note.emailSent && note.senderEmail"
                        activator="parent"
                        location="top"
                      >
                        Sent from: {{ note.senderEmail }}
                      </v-tooltip>
                    </div>
                    <span v-else>-</span>
                  </template>
                  <template v-slot:item.subject="{ item: note }">
                    <span v-if="note.subject">{{ note.subject }}</span>
                    <span v-else>-</span>
                  </template>
                  <template v-slot:item.content="{ item: note }">
                    <div class="note-content">{{ note.content }}</div>
                  </template>
                  <template v-slot:item.createdAt="{ item: note }">
                    {{ formatNoteDate(note.createdAt) }}
                  </template>
                  <template v-slot:bottom></template>
                  <template v-slot:no-data>
                    <div class="text-center pa-4">No notes for this user yet.</div>
                  </template>
                </v-data-table>
              </v-card-text>
            </v-card>
            <div class="d-flex justify-end mx-4 mb-4">
              <v-btn
                color="error"
                variant="outlined"
                prepend-icon="mdi-delete"
                data-cy="admin-delete-account-btn"
                @click="openDeleteAccountDialog(item)"
              >
                Delete account
              </v-btn>
            </div>
          </td>
        </template>
        <template v-slot:no-data>
          <v-alert v-if="search?.length" color="error" icon="mdi-alert">
            Your search for "{{ search }}" found no results.
          </v-alert>
          <div v-else>
            No data available
          </div>
        </template>
      </v-data-table>
      <div v-if="nextTokenUsers && !loadingUsers" class="text-center pa-4">
        <v-btn @click="handleLoadMoreUsers" :loading="loadingUsers">Load More Users</v-btn>
      </div>
    </v-window>
    <admin-delete-account-dialog
      v-model="deleteAccountDialog"
      :user="deleteAccountUser"
      @deleted="handleAccountDeleted"
    />
  </v-card>
</template>

<script>
import SES from '@/ses'
import store from '@/store'
import { mapState } from 'vuex'
import debounce from '@/utils/debounce'
import { ENTERPRISE_CUSTOMER_ID_PREFIX, OUTGOING_EMAIL_TEMPLATE_KEY } from '@/utils/constants'
import { UserSortableField, SortOrder } from '@/store/user/user'
import brand from '@/composables/useBrand'
import AdminDeleteAccountDialog from '@/components/AdminDeleteAccountDialog.vue'

export default {
  components: {
    AdminDeleteAccountDialog
  },
  data: () => ({
    tab: 'registeredUsers',
    dialog: [],
    deleteAccountDialog: false,
    deleteAccountUser: null,
    search: '',
    expanded: [],
    debouncedFetchUsers: null,
    newNotes: {},
    newNoteTypes: {},
    addingNoteState: {},
    senderEmailPrefixes: {},
    senderEmailErrors: {},
    subjectLines: {},
    noteTypeOptions: ['Incoming Email', 'Outgoing Email', 'Other'],
    headersAdminNotes: [
      { title: 'Type', key: 'type', sortable: true, width: '10%' },
      { title: 'Sent', key: 'emailSent', sortable: true, width: '6%' },
      { title: 'Subject', key: 'subject', sortable: false, width: '18%' },
      { title: 'Note', key: 'content', sortable: false, width: '32%' },
      { title: 'Author', key: 'author', sortable: true, width: '14%' },
      { title: 'Date', key: 'createdAt', sortable: true, width: '15%' }
    ],
    headersUsers: [
      { title: '', key: 'hasNotes', sortable: false, width: '1%' },
      {
        title: 'Name',
        sortable: false,
        key: 'firstname'
      },
      {
        title: 'Company',
        sortable: false,
        key: 'company'
      },
      {
        title: 'Email',
        sortable: false,
        key: 'email'
      },
      {
        title: 'Projects / Memberships',
        sortable: false,
        key: 'projectsAndMemberships',
        align: 'center'
      },
      {
        title: 'Subscription',
        sortable: false,
        key: 'subscription'
      },
      {
        title: 'Last Login',
        sortable: true,
        key: 'lastLogin',
        width: '10%'
      },
      {
        title: 'Login count',
        sortable: true,
        key: 'loginCounter'
      },
      {
        title: 'Registration Date',
        sortable: true,
        key: 'registrationDate'
      },
      {
        title: 'Referral Source',
        sortable: false,
        key: 'referralSource'
      },
      {
        title: 'Usage Intent',
        sortable: false,
        key: 'usageIntent'
      },
      {
        key: 'data-table-expand'
      }
    ],
    headersWorkflows: [
      {
        title: 'Name',
        align: 'left',
        sortable: true,
        key: 'name'
      },
      {
        title: 'Events',
        align: 'right',
        sortable: false,
        key: 'eventsLength'
      }
    ],
    headersProjects: [
      {
        title: 'Project Name',
        sortable: true,
        key: 'name'
      },
      {
        title: 'Organisation',
        sortable: true,
        key: 'organisation.name'
      },
      {
        title: 'Workflows',
        sortable: false,
        key: 'workflows'
      },
      {
        title: 'Team Members',
        sortable: false,
        key: 'teamMembers'
      },
      {
        title: 'Get access as team member',
        sortable: false,
        key: 'getAccess'
      },
      {
        title: 'Last login by a team member',
        align: 'end',
        sortable: false,
        key: 'lastLogin'
      }
    ]
  }),
  computed: {
    brand: () => brand,
    ...mapState({
      users: state => state.user.users,
      nextTokenUsers: state => state.user.nextTokenUsers,
      loadingUsers: state => state.user.loadingUsers,
      searchTerm: state => state.user.searchTerm,
      sortBy: state => state.user.sortBy,
      subscriptions: state => state.subscriptions.subscriptions
    }),
    subscriptionTypeByEmail () {
      if (!this.subscriptions) return {}

      const map = {}
      for (const sub of this.subscriptions) {
        if (!sub.payerUser?.stripeCustomerId) continue

        const customerId = sub.payerUser.stripeCustomerId
        if (customerId.startsWith(ENTERPRISE_CUSTOMER_ID_PREFIX)) {
          map[sub.email] = 'Enterprise'
        } else if (customerId.startsWith('cus_')) {
          map[sub.email] = 'Stripe'
        }
      }
      return map
    },
    tableSort () {
      if (!this.sortBy || !this.sortBy.field) {
        return []
      }

      let tableKey = ''
      switch (this.sortBy.field) {
        case UserSortableField.REGISTRATION_DATE:
          tableKey = 'registrationDate'
          break
        case UserSortableField.LAST_LOGIN:
          tableKey = 'lastLogin'
          break
        case UserSortableField.LOGIN_COUNTER:
          tableKey = 'loginCounter'
          break
        default:
          return []
      }

      return [{ key: tableKey, order: this.sortBy.order.toLowerCase() }]
    }
  },
  methods: {
    async handleAddNote (userId, sendEmail = false) {
      const content = this.newNotes[userId]?.trim()
      const type = this.newNoteTypes[userId] || 'Other'
      if (!content) {
        return
      }

      this.addingNoteState[userId] = sendEmail ? 'email' : 'note'

      const senderEmailPrefix = this.senderEmailPrefixes[userId]?.trim()
      const senderEmail = senderEmailPrefix ? `${senderEmailPrefix}@${brand.emails.domain}` : brand.emails.support
      const subject = this.subjectLines[userId]?.trim() || null
      const shouldSendEmail = sendEmail && type === 'Outgoing Email'
      const user = this.users.find((u) => u.id === userId)
      let emailSentSuccessfully = false

      try {
        if (shouldSendEmail) {
          if (!user?.email) {
            store.commit('snackbar/showMessage', {
              content: 'User has no email address',
              timeout: 6000,
              color: 'error',
              location: 'bottom right'
            }, { root: true })
            this.addingNoteState[userId] = false
            return
          }

          await new SES().sendAdminEmail(user.email, content, senderEmail, subject)
          emailSentSuccessfully = true

          localStorage.setItem(OUTGOING_EMAIL_TEMPLATE_KEY, JSON.stringify({
            senderEmailPrefix: senderEmailPrefix || 'support',
            subject,
            content
          }))
        }

        await this.$store.dispatch('user/addAdminNote', {
          userId,
          content,
          type: type || 'Other',
          subject,
          emailSent: shouldSendEmail,
          senderEmail: shouldSendEmail ? senderEmail : null
        })

        if (shouldSendEmail) {
          store.commit('snackbar/showMessage', {
            content: `Email sent to ${user.email}`,
            timeout: 4000,
            color: 'success',
            location: 'bottom right'
          }, { root: true })
        }

        this.newNotes[userId] = ''
        this.newNoteTypes[userId] = null
        this.senderEmailPrefixes[userId] = ''
        this.senderEmailErrors[userId] = null
        this.subjectLines[userId] = ''
      } catch (error) {
        let errorMessage = 'Error adding note'
        if (sendEmail) {
          errorMessage = emailSentSuccessfully
            ? 'Email was sent but failed to save note. Please add the note manually.'
            : 'Failed to send email. Note was not saved.'
        }
        store.commit('snackbar/showMessage', {
          content: errorMessage,
          timeout: 6000,
          color: 'error',
          location: 'bottom right'
        }, { root: true })
      } finally {
        this.addingNoteState[userId] = false
      }
    },

    validateSenderEmail (userId) {
      const value = this.senderEmailPrefixes[userId] || ''

      if (value.includes('@')) {
        this.senderEmailErrors[userId] = 'Do not include @ - domain will be added automatically'
        return false
      }

      if (value && !/^[a-zA-Z0-9._+-]+$/.test(value)) {
        this.senderEmailErrors[userId] = 'Only letters, numbers, dots, hyphens, underscores and + allowed'
        return false
      }

      if (value && (value.startsWith('.') || value.endsWith('.') || value.includes('..'))) {
        this.senderEmailErrors[userId] = 'Cannot start/end with dot or have consecutive dots'
        return false
      }

      this.senderEmailErrors[userId] = null
      return true
    },

    formatNoteDate (isoString) {
      if (!isoString) return ''
      const date = new Date(isoString)
      return date.toLocaleDateString('sv-SE') + ' ' + date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })
    },
    getNoteTypeColor (type) {
      switch (type) {
        case 'Incoming Email':
          return 'blue'
        case 'Outgoing Email':
          return 'green'
        case 'Other':
          return 'grey'
        default:
          return 'secondary'
      }
    },
    toggleRowExpansion (item) {
      const index = this.expanded.findIndex((id) => id === item.id)

      if (index > -1) {
        this.expanded.splice(index, 1)
      } else {
        this.expanded.push(item.id)
      }
    },
    formatProjectsAndMemberships (item) {
      const projects = this.countProjects(item.organisations)
      const memberships = this.countMemberships(item.projectMemberships) - projects
      return `${projects} / ${memberships}`
    },
    alreadyTeamMember (teamMembers) {
      for (const teamMember of teamMembers) {
        if (teamMember.userId === store.state.userId) {
          return true
        }
      }
      return false
    },
    async createTeamMember (projectId) {
      await store.dispatch('teamMembers/createTeamMember', {
        email: store.state.userInfo,
        projectId
      })
    },
    gotoWorkflow (workflowId, projectId) {
      const routeData = this.$router.resolve('/workflow/' + projectId + '/' + workflowId)
      window.open(routeData.href, '_blank')
    },
    countProjects (organisations) {
      let res = 0
      for (let i = 0; i < organisations.length; i++) {
        res = res + organisations[i].projects.length
      }
      return res
    },
    countMemberships (projectMemberships) {
      return projectMemberships ? projectMemberships.length : 0
    },
    getProjects (organisations) {
      const res = []
      for (let i = 0; i < organisations.length; i++) {
        res.push(...organisations[i].projects)
      }
      return res
    },
    findLastLogin (teamMembers) {
      let lastLogin = ''
      for (let i = 0; i < teamMembers.length; i++) {
        if (teamMembers[i].lastLogin > lastLogin) {
          lastLogin = teamMembers[i].lastLogin
        }
      }
      return lastLogin
    },
    mapTableSort (tableSortArray) {
      if (!tableSortArray || tableSortArray.length === 0) {
        return null
      }

      const tableSort = tableSortArray[0]
      let field

      switch (tableSort.key) {
        case 'registrationDate':
          field = UserSortableField.REGISTRATION_DATE
          break
        case 'lastLogin':
          field = UserSortableField.LAST_LOGIN
          break
        case 'loginCounter':
          field = UserSortableField.LOGIN_COUNTER
          break
        default:
          return null
      }

      return {
        field,
        order: tableSort.order.toUpperCase() === 'ASC' ? SortOrder.ASC : SortOrder.DESC
      }
    },

    async handleTableSort (newSortByTableFormat) {
      const sortInput = this.mapTableSort(newSortByTableFormat)

      const variables = {
        search: this.searchTerm,
        append: false,
        fetchAllForSearch: this.searchTerm.length > 0,
        ...(sortInput && { sortBy: sortInput })
      }

      await this.$store.dispatch('user/listUsers', variables)
    },

    async fetchUsers (append = false) {
      const searchTerm = (this.search || '').trim()
      const shouldFetchAll = searchTerm.length > 0 && !append

      await this.$store.dispatch('user/listUsers', {
        search: searchTerm,
        sortBy: this.sortBy,
        append,
        nextToken: append ? this.nextTokenUsers : null,
        fetchAllForSearch: shouldFetchAll
      })
    },

    async handleLoadMoreUsers () {
      if (this.nextTokenUsers && !this.loadingUsers) {
        await this.$store.dispatch('user/listUsers', {
          search: this.searchTerm,
          sortBy: this.sortBy,
          nextToken: this.nextTokenUsers,
          append: true,
          fetchAllForSearch: false
        })
      }
    },

    loadEmailTemplate (userId) {
      const saved = localStorage.getItem(OUTGOING_EMAIL_TEMPLATE_KEY)
      if (saved) {
        try {
          const template = JSON.parse(saved)
          this.senderEmailPrefixes[userId] = template.senderEmailPrefix || 'support'
          this.subjectLines[userId] = template.subject || ''
          this.newNotes[userId] = template.content || ''
        } catch (e) {
          // Invalid JSON, ignore
        }
      }
    },
    handleNoteTypeChange (userId, newType) {
      if (newType === 'Outgoing Email') {
        this.loadEmailTemplate(userId)
      }
    },
    openDeleteAccountDialog (user) {
      this.deleteAccountUser = user
      this.deleteAccountDialog = true
    },
    handleAccountDeleted (userId) {
      this.$store.commit('user/setUsers', { items: this.users.filter((user) => user.id !== userId) })
      this.expanded = this.expanded.filter((id) => id !== userId)
      this.$store.dispatch('subscriptions/listSubscriptions')
      store.commit('snackbar/showMessage', {
        content: 'Account deleted',
        timeout: 4000,
        color: 'success',
        location: 'bottom right'
      }, { root: true })
    }
  },
  created () {
    this.debouncedFetchUsers = debounce(() => {
      this.fetchUsers(false)
    }, 500)
  },
  mounted () {
    this.fetchUsers(false)
    this.$store.dispatch('subscriptions/listSubscriptions')
  },
  watch: {
    search (newSearch, oldSearch) {
      if (newSearch !== oldSearch) {
        this.debouncedFetchUsers()
      }
    }
  }
}
</script>

<style scoped>
.card {
  border-radius: 12px;
  background: var(--light-1);
  border: 1px solid var(--light-1);
  padding: 12px 16px 16px !important;
  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.15);
}

.note-content {
  padding: 8px;
  font-size: 14px;
  white-space: pre-wrap;
  word-break: break-word;
}
</style>
